var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.1665,
    cy: 4.1665,
    r: 2.5,
    fill: "#5A5A5A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8335,
    cy: 15.8335,
    r: 2.5,
    fill: "#5A5A5A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54142 4.1665C8.54142 3.82133 8.82124 3.5415 9.16642 3.5415H13.443C15.7357 3.5415 16.6076 6.53567 14.6733 7.76656L5.99728 13.2877C5.11807 13.8472 5.51439 15.2082 6.55652 15.2082H9.32421L9.14115 15.0251C8.89707 14.781 8.89707 14.3853 9.14115 14.1412C9.38523 13.8972 9.78095 13.8972 10.025 14.1412L11.275 15.3912C11.5191 15.6353 11.5191 16.031 11.275 16.2751L10.025 17.5251C9.78095 17.7692 9.38523 17.7692 9.14115 17.5251C8.89707 17.281 8.89707 16.8853 9.14115 16.6412L9.32421 16.4582H6.55652C4.26382 16.4582 3.39194 13.464 5.32619 12.2331L14.0022 6.71198C14.8814 6.15249 14.4851 4.7915 13.443 4.7915H9.16642C8.82124 4.7915 8.54142 4.51168 8.54142 4.1665Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouting);
export default __webpack_public_path__ + "static/media/routing.d3cb361556f4a637cd4b09d3f5fe7426.svg";
export { ForwardRef as ReactComponent };